export const datePickerClassName =
  "h-10 px-3 py-2 bg-white text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-zinc-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border border-zinc-200 rounded-md w-full";

export const calendarClassName = {
  className: `
    !shadow-md !border !border-zinc-200 !rounded-md !bg-white
    ![&_.react-calendar__navigation]:p-2
    ![&_.react-calendar__navigation_button]:text-xl
    ![&_.react-calendar__month-view__weekdays]:uppercase
    ![&_.react-calendar__month-view__weekdays]:font-normal
    ![&_.react-calendar__month-view__weekdays]:text-zinc-500
    ![&_.react-calendar__month-view__days__day]:h-10
    ![&_.react-calendar__month-view__days__day]:w-10
    ![&_.react-calendar__tile--active]:bg-blue-600
    ![&_.react-calendar__tile--active]:text-white
    ![&_.react-calendar__tile--active]:rounded-md
    ![&_.react-calendar__tile]:rounded-md
    ![&_.react-calendar__tile:hover]:bg-zinc-100
    ![&_.react-calendar__tile--now]:bg-transparent
    ![&_.react-calendar__tile--now]:text-blue-600
    ![&_.react-calendar__month-view__days__day--neighboringMonth]:text-zinc-300
  `,
};
